<template>
  <div class="qualification-policy-builder" data-testid="qualification-policy-builder">
    <RuleBuilderGroup
      :group="modelValue"
      :config="QUALIFICATION_RULE_BUILDER_CONFIG"
      operator-label="O médico precisa atender a"
      @update:group="onGroup"
    >
      <template #rule="{ rule, update, index }">
        <CriterionEditor
          :model-value="valueOf(rule)"
          :test-id="`qualification-criterion-${index}`"
          @update:model-value="update"
        />
      </template>
    </RuleBuilderGroup>
    <p
      v-if="!modelValue.children.length"
      class="mt-2 text-left text-sm text-gray-500"
      data-testid="qualification-policy-builder-empty"
    >
      Nenhum critério. Use <strong>+ Critério</strong> para exigir um selo ou documento, ou
      <strong>Grupo</strong> para combinar critérios com "Qualquer um - OU".
    </p>
  </div>
</template>

<script setup lang="ts">
import RuleBuilderGroup from '@/components/designSystem/RuleBuilder/RuleBuilderGroup.vue'
import type {
  RuleBuilderGroup as RuleBuilderGroupType,
  RuleBuilderRule
} from '@/components/designSystem/RuleBuilder/types'
import type {
  QualificationRuleGroup,
  QualificationRuleValue
} from '@/types/qualification-policy.types'

import CriterionEditor from './CriterionEditor.vue'
import { QUALIFICATION_RULE_BUILDER_CONFIG } from './policyModel'

defineProps<{ modelValue: QualificationRuleGroup }>()
const emit = defineEmits<{ 'update:modelValue': [value: QualificationRuleGroup] }>()

// O RuleBuilderGroup é genérico (`unknown`); a árvore editada é sempre a da qualificação.
const onGroup = (group: RuleBuilderGroupType<string, unknown>) =>
  emit('update:modelValue', group as QualificationRuleGroup)
const valueOf = (rule: unknown) => (rule as RuleBuilderRule<QualificationRuleValue | null>).value
</script>

<style>
/* A linha do RuleBuilderGroup tem altura fixa (h-16) para um select; o critério tem até 3 controles. */
#app .qualification-policy-builder .h-16 {
  height: auto;
  min-height: 4rem;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
